// TODO: find out why jest complains on React.Component, React.lazy, etc.
import React, { Component } from 'react';
import { JOIN } from '@/util/enums/EnumLayers';
import { ModalJoin, type ModalJoinProps } from './ModalJoin';

// eslint-disable-next-line camelcase
class ModalJoin_WITH_DEPRICATED_STATIC_METHODS extends Component<ModalJoinProps> {
  static modalType() {
    return JOIN;
  }

  static reducer(modals: any) {
    return modals.joinModal;
  }

  static title() {
    return 'Join a table';
  }

  static subTitle() {
    return <span>Proposed join options will be listed below.</span>;
  }

  render() {
    return <ModalJoin {...this.props} />;
  }
}

// eslint-disable-next-line camelcase
export default ModalJoin_WITH_DEPRICATED_STATIC_METHODS;
